export const AVAILABLE_IMAGE_SIZES = [56, 64, 72, 156, 360]
export const PROFILE_IMAGE_EXTENSION = '.webp'
